/** Longer than the 200ms slide-out (`--duration-normal`), in case `animationend` never fires. */
const EXIT_FALLBACK_MS = 300;

/**
 * Closes a hand-rolled overlay after its CSS exit animation. Adds `is-closing` to `element` and
 * runs `done` once the animation that class starts has finished. When the class starts no
 * animation (e.g. desktop, where `.mobile-slide-in-page` only animates on mobile), `done` runs at
 * once, so the CSS alone decides when there is something to wait for. A second call while the
 * element is already closing is ignored.
 */
export function closeAfterExitAnimation(element: HTMLElement | undefined, done: () => void): void {
  if (!element) {
    done();
    return;
  }
  if (element.classList.contains("is-closing")) {
    return;
  }

  element.classList.add("is-closing");
  const { animationName } = getComputedStyle(element);
  if (!animationName || animationName === "none") {
    element.classList.remove("is-closing");
    done();
    return;
  }

  let finished = false;
  const finish = () => {
    if (finished) {
      return;
    }
    finished = true;
    element.removeEventListener("animationend", onAnimationEnd);
    clearTimeout(fallback);
    done();
    element.classList.remove("is-closing");
  };
  const onAnimationEnd = (event: AnimationEvent) => {
    // Ignore animations bubbling up from children.
    if (event.target === element) {
      finish();
    }
  };
  element.addEventListener("animationend", onAnimationEnd);
  const fallback = setTimeout(finish, EXIT_FALLBACK_MS);
}
